import React from "react";
import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import { countryPhoneCodes } from "utils/constants";

import FormValidation from "./FormValidation";

function RegistrationForm({
  index,
  formValues,
  handleFormInput,
  isRegistrationFormValid,
  genderOptions,
  jerseySizeOptions,
  formErrors,
  onSizeChange,
}) {
  const { t } = useTranslation();

  // remove duplicate codes
  const newCountryPhoneCodes = countryPhoneCodes.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.code === value.code),
  );

  // open chart size
  const openChartSize = () => {
    Swal.fire({
      imageUrl:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0c0bcb47d291abbb37b7fae131a016d3ac964da15d4c553938e3c70e438f1cb197af3c9da28e2913a1480054712943aac6d73dcfb1238c120de08e6f0b9badd49aa18c642187923e3f135ff6c46bb57742a7e28b1dcd53f78642bb58cf52a36829592646754cd71bf63ffa8ac598110372f1a9add88c766bae51/file-1777953272490.jpeg",
      // "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/7c4722f4671d658ff921dd2af73fab92dbf421cceafaeb07653d4a44f468385c83c358e395831cd58e3a0547d70939bba968fe303a72abc631669b3015b86fea37d1e4d8bd99a6e1d9cce316d788786202b1e3ee627a11416cec8385a076d2fb912e622db46c4f869cddfe4c6a46beb5c763c9ccb6c625d22cc7/file-1752659684118.jpeg",
      imageAlt: "polo-shirt-chart-size",
      showConfirmButton: false,
      showCloseButton: false,
    });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-6 gap-x-8 gap-y-4">
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel1")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-name-${index}`]}
            placeholder={t("contactFormPlaceholder1")}
            type="text"
            name={`customer-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`customer-name-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel2")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-email-${index}`]}
            placeholder={t("contactFormPlaceholder2")}
            type="text"
            name={`customer-email-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`customer-email-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel7")} *
        </label>
        <div className="text-xs font-light text-red-500">
          {t("inputPhoneNumberExtraNote")}
        </div>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          {/* <select onChange={handleFormInput} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='px-2 text-sm font-bold outline-none select-none w-fit'>
            <option value='' selected></option>
            {newCountryPhoneCodes.sort((a, b) => a.code - b.code).map(((country) => (
              <option value={country.code}>{country.code}</option>
            )))}
          </select> */}
          <span>+</span>(
          <input
            type="number"
            onChange={handleFormInput}
            value={formValues[`customer-phcode-${index}`]}
            name={`customer-phcode-${index}`}
            className="w-8 text-sm font-bold text-center outline-none select-none"
          />
          <span>)</span>
          <input
            onChange={handleFormInput}
            value={formValues[`phone-number-${index}`]}
            name={`phone-number-${index}`}
            placeholder={t("contactFormPlaceholder7")}
            type="number"
            min="0"
            className="block w-full pl-2 text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />
        </div>
        <FormValidation
          errorType={formErrors[`phone-number-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel10")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={handleFormInput}
            value={formValues[`gender-${index}`]}
            name={`gender-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`gender-${index}`] ? "#9ca3af" : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {genderOptions.map((gender, idx) => (
              <option key={idx} value={gender.value}>
                {gender.name}
              </option>
            ))}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`gender-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel11")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={(e) => {
              handleFormInput(e);
              onSizeChange(e.target.value);
            }}
            value={formValues[`jersey-size-${index}`]}
            name={`jersey-size-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`jersey-size-${index}`]
                ? "#9ca3af"
                : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {jerseySizeOptions.map((size, idx) => {
              if (size.stock) {
                return (
                  <option key={idx} value={size.value}>
                    {size.name}
                  </option>
                );
              } else {
                return null;
              }
            })}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`jersey-size-${index}`]}
          showError={!isRegistrationFormValid}
        />
        <div className="pt-1 text-xs font-light">
          {t("inputJerseySizeExtraNote")}{" "}
          <span
            onClick={openChartSize}
            className="text-xs italic font-bold leading-6 text-gray-900 underline cursor-pointer"
          >
            {t("viewChartSize")}.
          </span>
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel3")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`company-name-${index}`]}
            placeholder={t("contactFormPlaceholder3")}
            type="text"
            name={`company-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`company-name-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel4")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-division-${index}`]}
            placeholder={t("contactFormPlaceholder4")}
            type="text"
            name={`customer-division-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`customer-division-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel6")}
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`id-number-${index}`]}
            placeholder={t("contactFormPlaceholder6")}
            type="number"
            name={`id-number-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel8")}
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`referral-code-${index}`]}
            placeholder={t("contactFormPlaceholder8")}
            type="text"
            name={`referral-code-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel9")}
        </label>
        <div className="mt-1">
          <textarea
            rows={5}
            onChange={handleFormInput}
            value={formValues[`notes-${index}`]}
            placeholder={t("contactFormPlaceholder9")}
            type="text"
            name={`notes-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
    </div>
  );
}

export default RegistrationForm;
